<ng-template #acknowledgeVariant>
  <section class="privacy-policy-page">
    <div class="left">
      <figure>
        <img alt="EY Logo" height="1816" [ngSrc]="imageURL()" priority width="432" />
      </figure>
    </div>
    <div class="right">
      <div class="policy-text">
        <article>
          <h1 class="text-center">{{ privacyNoticeName }}</h1>
          <div [innerHTML]="privacyNoticeBody"></div>
        </article>
        <div class="policy-consent">
          <button
            (click)="onAcknowledge()"
            [disabled]="isAckButtonDisabled"
            color="primary"
            motifButton
            [attr.aria-label]="'common.acknowledge' | translate">
            {{ 'common.acknowledge' | translate }}
          </button>
        </div>
      </div>
      <p class="policy-scroll-hint motif-caption-default-regular">
        <span>{{ 'privacy-notice.scroll-to-acknowledge' | translate }}</span>
        <motif-icon [iconFunction]="scrollHintIcon" aria-hidden="true" size="16" />
      </p>
    </div>
  </section>
</ng-template>

<ng-template #showVariant>
  <motif-modal-title>
    <h1 class="motif-subtitle-default-regular">{{ privacyNoticeName }}</h1>
    <button (click)="onCloseClicked()" color="link" motifButton [attr.aria-label]="'common.close' | translate">
      <motif-icon [iconFunction]="modalCloseIcon"> </motif-icon>
    </button>
  </motif-modal-title>

  <motif-modal-content>
    <div class="policy-text">
      <article>
        <div [innerHTML]="privacyNoticeBody"></div>
      </article>
    </div>
  </motif-modal-content>

  <motif-modal-actions>
    <button (click)="onCloseClicked()" color="primary" motifButton>
      {{ 'common.ok' | translate }}
    </button>
  </motif-modal-actions>
</ng-template>

@if (isAcknowledgeVariant) {
  <ng-container *ngTemplateOutlet="acknowledgeVariant"></ng-container>
} @else {
  <ng-container *ngTemplateOutlet="showVariant"></ng-container>
}
